module.exports = __webpack_public_path__ + "img/cc white.a49744ca.png";